import groupBy from 'lodash/groupBy'

import { Collection } from 'modules/core/lib/mobx-rest'

import type ApprovalGroup from 'modules/approvals/store/models/ApprovalGroup'
import ApprovalGroupMembership from 'modules/approvals/store/models/ApprovalGroupMembership'

class ApprovalGroupMemberships extends Collection<ApprovalGroupMembership> {
  get cacheKey(): string {
    return 'approvalGroupMemberships'
  }

  model() {
    return ApprovalGroupMembership
  }

  filterByApprovalGroup(approvalGroup: ApprovalGroup): ApprovalGroupMembership[] {
    const membershipsGroupedByGroup = groupBy(this.models, (e) => e.attributes.approval_group_id)

    return membershipsGroupedByGroup[approvalGroup.id] ?? []
  }
}

const singleton: ApprovalGroupMemberships = new ApprovalGroupMemberships()

export default singleton
